module.exports = __webpack_public_path__ + "static/img/MATTHEW_WADE.450f36b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MATTHEW_WADE.jpg
// module id = FPZx
// module chunks = 0